module.exports = __webpack_public_path__ + "img/flaubert.143d4ad4.jpg";